module.exports = __webpack_public_path__ + "media/images/thresholds_info-ad9e1699969d90096d4ba35ac6632e5c.png";